import React from 'react';
import { BLOCKING_REASON_MESSAGES } from '@24i/nxg-sdk-photon';
import { useTranslation } from 'react-i18next';
import { Container } from './styled';
export const BlockingMessage = ({ className, blockingReason, blockingMessage, }) => {
    const { t } = useTranslation(['sott']);
    const message = blockingReason in BLOCKING_REASON_MESSAGES
        ? t(`error.${BLOCKING_REASON_MESSAGES[blockingReason]}.body`)
        : blockingMessage;
    return React.createElement(Container, { className }, message);
};
BlockingMessage.displayName = 'BlockingMessage';
//# sourceMappingURL=index.js.map